import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState, useEffect, useRef, useContext } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import ShubhamImage from '../../assest/images/Shubham1.png';
import viewIcon from '../../assest/images/eye.png';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import axios from 'axios';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';

const AuditTrailReport = () => {

  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [right, setRight] = useState(true); // Initially, assume the user has rights
  const [redirecting, setRedirecting] = useState(false); // For showing the countdown
  const [timer, setTimer] = useState(3); // Countdown starting at 3 seconds
  const navigate = useNavigate(); // or useNavigation() if React Native
  const initialFromDate = new Date();
  initialFromDate.setMonth(initialFromDate.getMonth() - 1); // Set date one month ago
  const [selectedFromDate, setSelectedFromDate] = useState(initialFromDate);
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [AuditTransectionData, setAuditTransectionData] = useState([]);
  const [auditData, setAuditData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [auditTypes, setAuditTypes] = useState([]);
  const [selectedEnumVal, setSelectedEnumVal] = useState(null); // Set default to null (All)
  const [currentPage, setCurrentPage] = useState(1);
  const [alldata, setalldata] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [users, setUsers] = useState([]);
  const [currentPageRange, setCurrentPageRange] = useState([1, 10]); // Initial range 1-10
  const [ordersPerPage] = useState(10);
  const [user, setuser] = useState();
  const [fdate, setfdate] = useState();
  const [tdate, settdate] = useState();
  const [atype, setatype] = useState();
  const tableRef = useRef(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [CompanyFilter, setCompanyFilter] = useState(false);
  const [ScpFilter, setScpFilter] = useState(false);
  const [UserFilter, setUserFilter] = useState(false);
  const [ModuleFilter, setModuleFilter] = useState(true);
  const [Role, setRole] = useState();
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null); // Store CM_ID
  const [scpmasterData, setScpmasterData] = useState([]);
  const [selectedSCP, setSelectedSCP] = useState({
    value: null,
    label: 'Select Scp',
  });
  const [selectedSCPID, setSelectedSCPID] = useState();
  const [filterdisable, setfilterdisable] = useState(false);
  const [userdisable, setuserdisable] = useState(false);
  const [allcompanies, setAllcompanies] = useState();
  console.log("selectedSCPID DATA-", selectedSCPID)
  console.log("selectedSCP DATA-", selectedSCP)

  const ApiUsers = async (data) => {
    try {
      console.log("TRYING TO GET THE USER DATA BY SCP ID");
      const response = await axios.get(`${config.API_URL}/api/users/${data}`); // Call the API with the selected SCP ID
      console.log("$$$###################))))))))))))))))))))))))))))))))))))))))))))))))))))))-", response.data);
      setUsers(response.data); // Update users state with the response data
    } catch (err) {
      console.error("Error fetching users:", err); // Log the error for debugging
    }
  }

  const ProcessData = async (data) => {
    setalldata(data);
    setAuditData(data);
    setCurrentPage(1); // Reset currentPage to 1 after fetching new data
    setfdate(selectedFromDate)
    settdate(selectedToDate)
    setuser((selectedUserId === null) ? "All" : (selectedUserId === "null") ? "All" : selectedUserId)
    if (selectedEnumVal === "") {
      setatype("All")
    } else {
      for (let i = 0; i < auditTypes.length; i++) {
        if (auditTypes[i].EnumVal === selectedEnumVal) {
          setatype(auditTypes[i].Description)
        }
      }
    }
  }

  const DataApi = async (data) => {
    fetch(`${config.API_URL}/audittrail/byDate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        ProcessData(data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    const fetchUsersByScpId = async () => {
      if (Role === "ADMIN") {
        ApiUsers(selectedSCPID);
      }
    };
    // Run the fetch only if selectedSCPID is set (non-null)
    if (selectedSCPID) {
      fetchUsersByScpId();
    }
  }, [selectedSCPID]); // Run effect when selectedSCPID changes

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/api/user/${UM_UserId}`);
        console.log("API RESPONSE AT-", response.data.Role);
        setRole(response.data.Role)
        if (response.data.Right === "NO") {
          setRight(false);
          setRedirecting(true); // Start showing the countdown
        }
        if (response.data.Role === "ADMIN") {
          setModuleFilter(true);
          setUserFilter(true);
          setScpFilter(true);
        }
        if (response.data.Role === "SCP") {
          ApiUsers(selectedScpId);
          console.log("SCPSSSSSSSSSSSSSSSSSS")
          setRole(response.data.Role)
          setCompanyFilter(false);
          setScpFilter(false);
          setUserFilter(true);
        }
        if (response.data.Role === "SA") {
          console.log("#######################-SA")
          setRole(response.data.Role)
          setModuleFilter(true);
          setUserFilter(true);
          setScpFilter(true);
          setCompanyFilter(true);
        }
      } catch (err) {
        console.log("ERROR-", err.message);
      }
    };
    fetchData();
  }, [UM_UserId, config.API_URL]);

  useEffect(() => {
    const fetchUsers = async () => {
      if (Role === "SCP") {
        ApiUsers(selectedScpId);
      }
    };
    fetchUsers(); // Call the fetch function
  }, [selectedScpId, ScpFilter])

  useEffect(() => {
    if (Role === "SA") {
      fetch(`${config.API_URL}/api/companies`)
        .then((response) => response.json())
        .then((data) => {
          console.log("COMPANY OPTIONS-", data)
          setAllcompanies(data)
          const options = [
            { value: "ALL", label: 'ALL' }, // Added static "All" option
            ...data.map((company) => ({
              value: company.CM_ID, // This will be stored when a company is selected
              label: company.CM_CompanyName, // Display the company name in the dropdown
            })),
          ];
          setCompanies(options);
        })
        .catch((error) => console.error('Error fetching companies:', error));
    }
  }, [CompanyFilter]);

  useEffect(() => {
    if (selectedCompanyId > 0) {
      fetch(`${config.API_URL}/aapi/scpmaster/${selectedCompanyId}`)
        .then((response) => response.json())
        .then((data) => {
          const options = [
            { value: "ALL", label: 'All' }, // Static "All" option
            ...data.map((scp) => ({
              value: scp.SCPM_ID,
              label: scp.SCPM_Name,
            })),
          ];
          setScpmasterData(options);
          setSelectedSCP({ value: 'ALL', label: 'ALL' });
        })
        .catch((error) => console.error('Error fetching scpmaster data:', error));
    }
  }, [selectedCompanyId]);

  useEffect(() => {
    if (Role === "ADMIN") {
      fetch(`${config.API_URL}/aapi/scpmaster/${UM_CompanyID}`)
        .then((response) => response.json())
        .then((data) => {
          const options = [
            { value: "ALL", label: 'All' }, // Static "All" option
            ...data.map((scp) => ({
              value: scp.SCPM_ID,
              label: scp.SCPM_Name,
            })),
          ];
          setScpmasterData(options);
          setSelectedSCPID("ALL");
          setSelectedSCP({ value: "ALL", label: 'All' });
          setSelectedUserId(null);
          setSelectedOption(null);
          setuserdisable(true);
        })
        .catch((error) => console.error('Error fetching scpmaster data:', error));
    }
  }, [UM_CompanyID, Role]);

  useEffect(() => {
    const fetchUsers = async () => {
      if (Role === "SA") {
        ApiUsers(selectedSCPID);
      }
    };
    fetchUsers(); // Call the fetch function
  }, [selectedSCPID]);

  useEffect(() => {
    if (redirecting) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      const redirectTimeout = setTimeout(() => {
        navigate('/dashboard'); // Redirect to Dashboard after 5 seconds
      }, 5000);
      // Clear intervals and timeouts when component unmounts or when condition changes
      return () => {
        clearInterval(countdown);
        clearTimeout(redirectTimeout);
      };
    }
  }, [redirecting, navigate]);
  const [selectedOption, setSelectedOption] = useState({
    value: null,
    label: 'Select User',
  });
  const [selectedCompanyOption, setSelectedCompanyOption] = useState(companies[0]); // Set default option to "All"
  const options = [
    { value: null, label: 'All' }, // Added option for "Select"
    ...auditTypes.map(type => ({
      value: type.EnumVal,
      label: type.Description,
    }))
  ];
  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  const handleFromDateChange = (date) => {
    setSelectedFromDate(date);
  };
  useEffect(() => {
    if (users && users.length > 0) {
      console.log("Users loaded and options are being set");
      const updatedUserOptions = [
        { value: null, label: 'All' }, // Option for "All"
        ...users.map(user => ({
          value: user.UM_UserCode,
          label: user.UM_UserCode
        })),
      ];
      setUserOptions(updatedUserOptions);
      setSelectedOption({ value: null, label: 'All' });
      setSelectedUserId(null);
    }
  }, [users]);
  useEffect(() => {
    // Fetch data from the API
    fetch(`${config.API_URL}/api/audittypes`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        setAuditTypes(data);
        setError(null); // Clear any previous errors
      })
      .catch((error) => {
        setError('Failed to fetch audit types: ' + error.message);
        console.error('Error fetching audit types:', error);
      });
  }, []);
  const handleChange = (selectedOption) => {
    console.log(selectedOption);
    setSelectedEnumVal(selectedOption?.value || null);
  };
  const handleToDateChange = (date) => {
    setSelectedToDate(date);
  };

  const handleSearch = () => {
    if (selectedToDate < selectedFromDate) {
      toast.error("Invalid Date Format");
      return;
    }
    if (!selectedCompanyOption && Role === "SA") {
      toast.error("Please select a company.");
      return; // Return early to avoid further logic if the condition is met
    }
    if (Role === "ADMIN") {
      console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA")
      const AdminData = {
        fromDate: selectedFromDate,
        toDate: selectedToDate,
        cid: UM_CompanyID,
        Scpid: selectedSCPID,
        AUTR_AuditType: (selectedEnumVal == "") ? null : selectedEnumVal, // Include selectedUserId in requestData
        userId: selectedUserId
      };
      console.log("ADMIN DATA-", AdminData)
      DataApi(AdminData)
      return;
    }
    if (Role === "SA") {
      if (filterdisable && userdisable) {
        console.log("#######################################################################")
        const requestData1 = {
          fromDate: selectedFromDate,
          toDate: selectedToDate,
          companyId: selectedCompanyId,
          AUTR_AuditType: (selectedEnumVal == "") ? null : selectedEnumVal, // Include selectedUserId in requestData
        };
        console.log("COMPANY AND MODULE")
        console.log("MODULE", selectedEnumVal)
        console.log("COMPANY", selectedCompanyId)
        fetch(`${config.API_URL}/audittrail/byDate/SA`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData1)
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            ProcessData(data);
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
        return;
      }
      if (filterdisable) {
        
        const requestData = {
          fromDate: selectedFromDate,
          toDate: selectedToDate,
          userId: "SuperAdmin",
          AUTR_AuditType: (selectedEnumVal == "") ? null : selectedEnumVal, // Include selectedUserId in requestData
          Cid: selectedCompanyId
        };
        console.log("DATA -", requestData)
        fetch(`${config.API_URL}/audittrail/byDate/saonly`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData)
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            ProcessData(data);
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
        return;
      }
      const requestData = {
        fromDate: selectedFromDate,
        toDate: selectedToDate,
        userId: selectedUserId,
        AUTR_AuditType: (selectedEnumVal == "") ? null : selectedEnumVal, // Include selectedUserId in requestData
        Scpid: userdisable ? "ALL" : selectedSCPID,
        cid: selectedCompanyId
      };
      console.log("HELLO-", requestData)
      DataApi(requestData)
    }
    if (Role === "SCP") {
      const requestData = {
        fromDate: selectedFromDate,
        toDate: selectedToDate,
        userId: selectedUserId,
        AUTR_AuditType: (selectedEnumVal == "") ? null : selectedEnumVal, // Include selectedUserId in requestData
        Scpid: selectedScpId
      };
      console.log("@@@@@@-", requestData)
      DataApi(requestData)
    }
  };
  const formatDate = (dateString) => {
    return format(new Date(dateString), 'dd-MM-yyyy HH:mm:ss');
  };
  const handleKeyDown = (event) => {
    event.preventDefault();
  };

  const totalPages = Math.ceil(auditData.length / ordersPerPage);
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      const newRangeStart = Math.floor((pageNumber - 1) / 10) * 10 + 1;
      const newRangeEnd = Math.min(newRangeStart + 9, totalPages);
      setCurrentPageRange([newRangeStart, newRangeEnd]);
    }
  };
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = auditData.slice(indexOfFirstOrder, indexOfLastOrder);

  const handleDownloadPDF = async () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });
    const textColor = [0, 0, 0]; // Black (RGB)
    const headerTextColor = [255, 255, 255]; // White (RGB)
    const headerColor = [135, 206, 250]; // Light Blue (RGB)
    const rowColor = [255, 255, 255]; // White (RGB)
    const styles = {
      title: {
        fontSize: 24,
        color: textColor,
        fontStyle: 'bold',
        margin: { top: 20 },
        align: 'center',
      },
      detailsTable: {
        fontSize: 12,
        color: textColor,
        margin: { top: 10 },
        fillColor: rowColor,
      },
      tableHeader: {
        fontSize: 12,
        color: headerTextColor,
        fontStyle: 'bold',
        fillColor: headerColor,
      },
      tableRow: {
        fontSize: 10, // Small font size for table rows
        color: textColor,
        fillColor: rowColor,
      },
      AuditReport: {
        fontSize: 14,
        halign: 'center',
        fillColor: [41, 128, 185],
        textColor: [255, 255, 255],
        align: 'center',
      },
    };
    const imgData = ShubhamImage;
    doc.addImage(imgData, 'PNG', 10, 10, 40, 20);
    const printedBy = `Printed By: ${UM_UserCode}`;
    const printedOn = `Printed On: ${new Date().toLocaleString()}`;
    const startX = doc.internal.pageSize.getWidth() - 50;
    const startY = 20;
    doc.setFontSize(8);
    doc.text(printedBy, startX, startY + 5, { textAlign: 'right', fontWeight: 'bold' });
    doc.text(printedOn, startX, startY, { textAlign: 'right', fontWeight: 'bold' });
    const headers = ['Sr. No.', 'AuditType', 'Date & Time', 'UserName', 'Parameter Name', 'Old Value', 'New Value', 'Message'];
    let tableData = [];
    if (alldata && alldata.length > 0) {
      alldata.forEach((row, index) => {
        const correspondingAuditTransactions = AuditTransectionData.filter(entry => entry.AUTRN_ID === row.AUTR_ID);
        // Main entry for alldata
        const mainRowData = [
          index + 1,
          row.AUTR_AuditType,
          new Date(row.AUTR_CreatedDateTime).toLocaleString('en-GB', { timeZone: 'UTC' }),
          row.AUTR_UserCode,
          '-', // Blank for Parameter Name
          '-', // Blank for Old Value
          '-', // Blank for New Value
          row.AUTR_Message,
        ];
        tableData.push(mainRowData);
        // Subentries for correspondingAuditTransactions
        correspondingAuditTransactions.forEach((transaction, subIndex) => {
          const subRowData = [
            `${1 + index}.${1 + subIndex}`, // Sr. No.
            '-', // AuditType
            '-', // Date & Time
            '-', // UserName
            transaction.AUTRN_ParamererName || '-', // Parameter Name (handle null or undefined)
            transaction.AUTRN_OldValue || '-', // Old Value (handle null or undefined)
            transaction.AUTRN_NewValue || '-', // New Value (handle null or undefined)
            '-', // Message will be left blank
          ];
          tableData.push(subRowData);
        });
      });
    } else {
      console.error('Error: alldata is empty or undefined.');
      return;
    }
    const criteria = [
      [{
        content: `Selected Criteria :- User : ${user} , AuditType : ${atype} , From : ${formatDate(fdate)} , To : ${formatDate(tdate)}`,
        colSpan: 2,
        styles: styles.criteria
      }]
    ];
    // Helper function to format date as dd-mm-yyyy
    function formatDate(dateString) {
      if (!dateString) return ''; // Handle empty or undefined dates
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    doc.autoTable({
      head: [],
      body: criteria,
      startY: 31,
      theme: 'grid',
      styles: {
        ...styles.criteria,
        cellPadding: 2,
        valign: 'middle',
        halign: 'left',
      },
    });
    const AuditReport = [
      [{ content: `Audit Report`, colSpan: 2, styles: styles.AuditReport }]
    ];
    doc.autoTable({
      head: [],
      body: AuditReport,
      startY: 40,
      theme: 'grid',
      styles: {
        ...styles.AuditReport,
        cellPadding: 2,
        valign: 'middle',
        halign: 'left',
      },
    });
    const auditReportHeight = doc.previousAutoTable.finalY; // Add a small gap after AuditReport
    const tableY = auditReportHeight; // Start of the table immediately after AuditReport
    let startTableY = tableY;
    doc.autoTable({
      head: [headers], // Ensure headers are passed as an array
      body: tableData,
      startY: startTableY,
      theme: 'grid',
      headStyles: {
        fillColor: [41, 128, 185], // Header background color
        textColor: headerTextColor, // Header text color
        lineWidth: 0.25,
        cellPadding: 2, // Padding inside cells
        valign: 'middle', // Vertical alignment
        halign: 'left', // Horizontal alignment
        minCellHeight: 8, // Minimum height of each cell
        border: {
          top: { style: 'solid', width: 0.25, color: [0, 0, 0] }, // Border style
        },
      },
      styles: {
        fontSize: 8, // Small font size for table data rows
        cellPadding: 2, // Padding inside cells
        valign: 'middle', // Vertical alignment
        halign: 'left', // Horizontal alignment
        textColor: textColor, // Text color for row data
      },
      columnStyles: {
        0: { cellWidth: 20 }, // Adjust column width if needed
        // Add more column styles as necessary
      },
    });
    const auditReportHeight1 = doc.previousAutoTable.finalY; // Add a small gap after AuditReport
    const tableY1 = auditReportHeight1 + 10;
    const lastsign = [
      [{
        content: ``
      }, {
        content: `Date`
      }, {
        content: `Sign`
      }],
      [{
        content: `Checked By :`
      }, {
        content: `....................`
      }, {
        content: `....................`
      }], [{
        content: `Verified By :`
      }, {
        content: `....................`
      }, {
        content: `....................`
      }]
    ];
    // Helper function to format date as dd-mm-yyyy
    doc.autoTable({
      head: [],
      body: lastsign,
      startY: tableY1,
      styles: {
        textColor: [0, 0, 0]
      }
    });

    const totalPages = Math.ceil(auditData.length / ordersPerPage);
    const paginate = (pageNumber) => {
      if (pageNumber >= 1 && pageNumber <= totalPages) {
        setCurrentPage(pageNumber);
        const newRangeStart = Math.floor((pageNumber - 1) / 10) * 10 + 1;
        const newRangeEnd = Math.min(newRangeStart + 9, totalPages);
        setCurrentPageRange([newRangeStart, newRangeEnd]);
      }
    };
    // Add page numbers in the footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.getHeight();
      const pageWidth = pageSize.getWidth();
      doc.setFontSize(8);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 20, pageHeight - 10, { align: 'right' });
    }
    doc.save(`Audit_Trail.pdf`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.API_URL}/alldata/audittransaction`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setAuditTransectionData(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Error fetching data');
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const onViewButtonClick = (id) => {
    const relevantData = AuditTransectionData.filter(item => item.AUTRN_ID === id);
    if (relevantData.length === 0) {
      console.error(`No data found for id ${id}`);
      return;
    }
    // Create overlay
    const overlay = document.createElement('div');
    overlay.classList.add('overlay');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    overlay.style.zIndex = '1000';
    overlay.style.display = 'flex'; // Use flexbox
    overlay.style.justifyContent = 'center'; // Horizontally center
    overlay.style.alignItems = 'center'; // Vertically center
    // Create dialog box
    const dialog = document.createElement('div');
    dialog.classList.add('dialog');
    dialog.style.backgroundColor = '#fff';
    dialog.style.padding = '20px';
    dialog.style.width = '60%'; // Adjust width as needed
    dialog.style.maxHeight = '70vh'; // Set maximum height relative to viewport
    dialog.style.borderRadius = '8px';
    dialog.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)'; // Add shadow for better visual
    dialog.style.position = 'relative'; // Ensure dialog has its own position
    dialog.style.overflowY = 'auto'; // Ensure dialog has its own position

    // Create table element
    const table = document.createElement('table');
    table.classList.add('data-table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';
    table.style.border = '1px solid #ededed';
    // Create table header
    const headerRow = document.createElement('tr');
    headerRow.style.backgroundColor = '#f2f2f2';
    const headerStyles = 'padding: 8px; text-align: left; border-bottom: 1px solid #ddd; color: #465a64; font-size: 14px;';
    headerRow.innerHTML = `
        <th style="${headerStyles}">Parameter Name</th>
        <th style="${headerStyles}">Old Value</th>
        <th style="${headerStyles}">New Value</th>
    `;
    table.appendChild(headerRow);
    // Populate table rows with data
    relevantData.forEach(data => {
      const row = document.createElement('tr');
      const rowStyles = 'padding: 8px; text-align: left; border-bottom: 1px solid #ddd; color: #465a64; font-size: 14px;';
      row.innerHTML = `
          <td style="${rowStyles}">${data.AUTRN_ParamererName}</td>
          <td style="${rowStyles}">${data.AUTRN_OldValue}</td>
          <td style="${rowStyles}">${data.AUTRN_NewValue}</td>
      `;
      table.appendChild(row);
    });
    // Close button
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.style.marginTop = '10px';
    closeButton.style.padding = '8px 16px';
    closeButton.style.backgroundColor = '#325880';
    closeButton.style.color = '#fff';
    closeButton.style.border = 'none';
    closeButton.style.cursor = 'pointer';
    closeButton.style.borderRadius = '7px';
    closeButton.style.height = '50px';
    closeButton.style.width = '17%';
    closeButton.style.fontSize = '18px';
    closeButton.style.fontWeight = '500';
    const closeOverlay = () => {
      overlay.remove();
    };
    // Add click event to the overlay to close if clicked outside the dialog
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) {
        closeOverlay();
      }
    });
    closeButton.addEventListener('click', closeOverlay);
    // Append table and close button to dialog
    dialog.appendChild(table);
    dialog.appendChild(closeButton);
    // Append dialog to overlay
    overlay.appendChild(dialog);
    // Append overlay to body
    document.body.appendChild(overlay);
  };

  useEffect(() => {
    if (selectedCompanyOption &&
      (selectedCompanyOption.value === 0 || selectedCompanyOption.value === null || selectedCompanyOption.value === "null")) {
      const fetchUsers = async () => {
        try {
          const response = await fetch(`${config.API_URL}/users?companyID=${selectedCompanyId}`);
          if (!response.ok) {
            throw new Error('Failed to fetch data');
          }
          const data = await response.json();
          setUsers(data);
          console.log("GETTING THE DATA OF SUPERADMIN-", data);
        } catch (err) {
          console.error('Error fetching data:', err);
        }
      };
      fetchUsers();
    }
  }, [selectedCompanyOption, selectedCompanyId]);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
    // logAction(`Select opened: ${selectName}`);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
    // logAction("Select closed");
  };
  return (
    <>
      <div>
        <div>
          {!right ? (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <h2>You don't have rights for this.</h2>
              <p>Redirecting to Dashboard in {timer} seconds...</p>
            </div>
          ) : (
            <>
              {loading ? (
                <div className='main_container'>
                  <h1 className='formHeading'>AuditTrail Report</h1>
                  <div class>Loading...</div>
                </div>
              ) : (
                <>
                  <ToastContainer></ToastContainer>
                  <div className='main_container'>
                    <h1 className='formHeading'>AuditTrail Report</h1>
                    <div className='row mb-4 align-items-center'>
                      <div className='col-md-2'>
                        <label>From</label>
                        <DatePicker
                          style={{ position: 'absolute', zIndex: 1 }}
                          id="orderDate"
                          selected={selectedFromDate}
                          onChange={handleFromDateChange}
                          maxDate={new Date()}
                          disableFuture
                          autoOk
                          dateFormat="dd-MM-yyyy"
                          className="form-input"
                          placeholderText="Select a date"
                          onKeyDown={handleKeyDown}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                        />
                      </div>
                      <div className='col-md-2'>
                        <label>To</label>
                        <DatePicker
                          style={{ position: 'absolute', zIndex: 1 }}
                          id="orderDate"
                          selected={selectedToDate}
                          onChange={handleToDateChange}
                          maxDate={new Date()}
                          disableFuture
                          autoOk
                          dateFormat="dd-MM-yyyy"
                          className="form-input"
                          placeholderText="Select a date"
                          onKeyDown={handleKeyDown}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                        />
                      </div>
                      {CompanyFilter && (<>
                        <div className="col-md-2">
                          <label>Company</label>
                          <div className='select-container_list'>
                    <Select
                            options={companies} // Pass the mapped companies as options
                            value={selectedCompanyOption}
                            onChange={(selectedOption) => {
                              setScpmasterData([]);
                              setUserOptions([]);
                              setSelectedCompanyId(selectedOption?.value || null); // Store CM_ID
                              setSelectedCompanyOption(selectedOption); // Update selected option for UI
                              setfilterdisable(false)
                              setSelectedSCPID("ALL");
                              setSelectedSCP(null);
                              setSelectedUserId(null);
                              setSelectedOption(null);
                              if (selectedOption.value === "ALL") {
                                setfilterdisable(true)
                                setuserdisable(true)
                              }
                              if (selectedOption.value === 0) {
                                setfilterdisable(true)
                                setuserdisable(false)
                              } else {
                                setuserdisable(true)
                              }
                            }}
                            className="routing_select-box"
                            placeholder="Select company"
                            onMenuOpen={() => handleSelectOpen('company')}
                            onMenuClose={handleSelectClose}
                          />
                              <div className='icon-container'>
                              {isSelectOpen === 'company' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                            </div>
                    </div>
                        </div>
                      </>)}
                      {ScpFilter && (<>
                        <div className='col-md-2'>
                          <label>SCP</label>
                          <div className='select-container_list'>
                            <Select
                              options={scpmasterData} // Pass the mapped companies as options
                              value={selectedSCP}
                              onChange={(selectedOption) => {
                                setUserOptions([]);
                                setSelectedSCPID(selectedOption?.value || null); // Store CM_ID
                                setSelectedSCP(selectedOption); // Update selected option for UI
                                setSelectedUserId(null);
                                setSelectedOption(null);
                                setuserdisable(false)
                                if (selectedOption.value === "ALL") {
                                  setuserdisable(true)
                                }
                              }}
                              placeholder="Select SCP"
                              isDisabled={filterdisable}
                              className="routing_select-box"
                              onMenuOpen={() => handleSelectOpen('selectedSCP')}
                              onMenuClose={handleSelectClose}
                            />
                            <div className='icon-container'>
                              {isSelectOpen === 'selectedSCP' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                            </div>
                          </div>
                        </div>
                      </>)}
                      <div className='col-md-2'>
                        <label>User</label>
                        <div className='select-container_list'>
                          <Select
                            options={userOptions}
                            value={selectedOption}
                            onChange={(selectedOption) => {
                              setSelectedUserId(selectedOption?.value || null);
                              setSelectedOption(selectedOption); // Update selected option
                            }}
                            isDisabled={userdisable}
                          className="routing_select-box"
                          onMenuOpen={() => handleSelectOpen('userOptions')}
                          onMenuClose={handleSelectClose}
                          />
                          <div className='icon-container'>
                            {isSelectOpen === 'userOptions' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                          </div>
                        </div>
                      </div>
                      <div className='col-md-2'>
                        <label>Audit</label>
                        <div className='select-container_list'>
                          <Select
                            options={options}
                            value={options.find(option => option.value === selectedEnumVal)}
                            onChange={handleChange}
                            placeholder="Select AuditType"
                            className="routing_select-box"
                            onMenuOpen={() => handleSelectOpen('AuditType')}
                            onMenuClose={handleSelectClose}
                          />
                          <div className='icon-container'>
                            {isSelectOpen === 'AuditType' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                          </div>
                        </div>
                      </div>
                      <div className='col-md-4 mt-4'>
                        <button
                          type="button"
                          className="search_btn col-md-5 me-3"
                          style={{ marginLeft: '0px' }}
                          onClick={handleSearch}
                        >SEARCH
                        </button>
                        {(alldata.length > 0) ? (
                          <button
                            type="button"
                            className="report_btn col-md-6"
                            // style={{ marginLeft: '0px' }}
                            onClick={handleDownloadPDF}
                          >DOWNLOAD REPORT
                          </button>
                        ) : <button
                          className="report_btn col-md-6"
                        >DOWNLOAD REPORT</button>}
                      </div>
                    </div>
                    <div className="ptable-wrapper" ref={tableRef} >
                      <table id="audit-table" className="ptableClass">
                        <thead>
                          <tr>
                            <th>Sr. No.</th>
                            <th>AuditType</th>
                            <th>Message</th>
                            <th>UserName</th>
                            <th>TimeStamp</th>
                            <th>VIEW</th>
                          </tr>
                        </thead>
                        {currentOrders.length === 0 ? (
                          <tbody>
                            <tr>
                              <td colSpan="10">No Records Found</td>
                            </tr>
                          </tbody>
                        ) : (
                          <tbody>
                            {currentOrders.map((item, index) => {
                              // Check if AUTR_ID exists in AuditTransectionData
                              const showViewButton = AuditTransectionData.some(dataItem => dataItem.AUTRN_ID === item.AUTR_ID);
                              return (
                                <tr key={item.AUTR_ID}>
                                  <td>{indexOfFirstOrder + index + 1}</td>
                                  <td>{item.AUTR_AuditType}</td>
                                  <td>{item.AUTR_Message}</td>
                                  <td>{item.AUTR_UserName}</td>
                                  <td>{formatDate(item.AUTR_CreatedDateTime)}</td>
                                  {showViewButton ? (
                                    <td>
                                      <img src={viewIcon} alt='view'
                                        style={{ width: '20px', height: '20px' }}
                                        onClick={() => onViewButtonClick(item.AUTR_ID)}>
                                      </img>
                                    </td>
                                  ) : (
                                    <td>-</td> // Render an empty cell if VIEW button shouldn't be shown
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        )}
                      </table>
                    </div>
                  </div>
                  <ul className="pagination">
                    <li className={currentPage === 1 || totalPages === 0 ? "page-item disabled" : "page-item"}>
                      <button className="page-linkd" onClick={() => paginate(1)}>First</button>
                    </li>
                    <li className={currentPage === 1 || totalPages === 0 ? "page-item disabled" : "page-item"}>
                      <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
                    </li>
                    {Array.from({ length: totalPages }).map((_, index) => {
                      const pageNumber = index + 1;
                      if (pageNumber >= currentPageRange[0] && pageNumber <= currentPageRange[1]) {
                        return (
                          <li key={index} className={currentPage === pageNumber ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(pageNumber)}>{pageNumber}</button>
                          </li>
                        );
                      }
                      return null;
                    })}
                    <li className={currentPage === totalPages || totalPages === 0 ? "page-item disabled" : "page-item"}>
                      <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
                    </li>
                    <li className={currentPage === totalPages || totalPages === 0 ? "page-item disabled" : "page-item"}>
                      <button className="page-linkd" onClick={() => paginate(totalPages)}>Last</button>
                    </li>
                  </ul>

                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default AuditTrailReport;